import { render, staticRenderFns } from "./PublicShell.vue?vue&type=template&id=0c8879dc&scoped=true"
import script from "./PublicShell.vue?vue&type=script&lang=js"
export * from "./PublicShell.vue?vue&type=script&lang=js"
import style0 from "./PublicShell.vue?vue&type=style&index=0&id=0c8879dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8879dc",
  null
  
)

export default component.exports